var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from "@wordpress/element";
import { __, sprintf } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { ButtonType, WPQTButton, } from "../../../../components/common/Button/Button";
import { WPQTField } from "../../../../components/common/Form/Field";
import { WPQTFieldSet } from "../../../../components/common/Form/FieldSet";
import { InputType, WPQTInput, } from "../../../../components/common/Input/Input";
import { Loading } from "../../../../components/Loading/Loading";
import { logInUserPageRequest } from "../../../api/user-page-api";
import { SET_USER_LOGGED_IN } from "../../../constants";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { useSession } from "../../../hooks/useSession";
import { UserPageAppContext } from "../../../providers/UserPageAppContextProvider";
import { PageScreenMiddle, PageTitle } from "../Page/Page";
function LoginPage() {
    const { state: { pageHash, userName }, userPageAppDispatch, } = useContext(UserPageAppContext);
    const { setSessionCookie } = useSession();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { handleError } = useErrorHandler();
    const login = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        if (!password) {
            toast.error(__("Please enter a password", "quicktasker"));
            return;
        }
        try {
            setLoading(true);
            const response = yield logInUserPageRequest(pageHash, password);
            yield setSessionCookie(response.data);
            userPageAppDispatch({ type: SET_USER_LOGGED_IN, payload: true });
        }
        catch (error) {
            setLoading(false);
            handleError(error);
        }
    });
    return (_jsxs(PageScreenMiddle, { children: [_jsx(PageTitle, { titleClassName: "wpqt-font-normal", className: "wpqt-mb-2", description: __("Please log in to continue", "quicktasker"), children: sprintf(__("Hello %s", "quicktasker"), userName) }), _jsx("form", { onSubmit: login, children: _jsxs(WPQTFieldSet, { children: [_jsx(WPQTField, { children: _jsx(WPQTInput, { value: password, onChange: setPassword, type: InputType.PASSWORD }) }), _jsx(WPQTField, { className: "wpqt-flex wpqt-justify-center", children: loading ? (_jsx(Loading, { ovalSize: "32" })) : (_jsx(WPQTButton, { btnText: __("Login", "quicktasker"), type: ButtonType.SUBMIT })) })] }) }), _jsx(ForgotPassword, {})] }));
}
function ForgotPassword() {
    const [guideOpen, setGuideOpen] = useState(false);
    return (_jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-gap3 wpqt-items-center wpqt-mt-2 wpqt-text-sm wpqt-cursor-pointer wpqt-relative wpqt-min-w-[300px] wpqt-text-blue-500", onClick: () => setGuideOpen(!guideOpen), children: [_jsx("div", { className: "wpqt-mb-2", children: __("Forgot the password?", "quicktasker") }), _jsx("div", { className: `wpqt-text-center wpqt-absolute wpqt-top-full wpqt-left-0 wpqt-w-full ${guideOpen ? "wpqt-animate-fadeIn" : "wpqt-animate-fadeOut"} ${!guideOpen && "wpqt-hidden"}`, children: __("Please contact the site admin to reset your password", "quicktasker") })] }));
}
export { LoginPage };
